import { Divider, Stack, Typography, Box, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { RiStackLine } from 'react-icons/ri'

export default function PlanAndPayment() {

    const theme = useTheme()
    
    return (
        <Stack
            direction="column"
            spacing={1}
            sx={{width: "100%"}}
        >
            <Typography
                variant="subtitle1"
                color={grey["400"]}
                fontWeight="400"
                sx={{
                    marginTop: "2rem"
                }}
            >
                Plan And Payment
            </Typography>
            <Divider />

            <Stack
                direction="column"
                spacing={2}
            >
                <Stack
                    direction="row"
                    padding="0.5rem"
                    spacing={1}
                    display="flex"
                    bgcolor={theme.palette.primary.light}
                    border= {`0.5px solid ${theme.palette.secondary.main}`}
                    borderRadius={theme.shape.borderRadius}
                >
                    <Box
                        sx={{
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            borderRadius: "100%",
                            width: "1.5rem",
                            height: "1.5rem",
                            display: 'flex',
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <RiStackLine color={grey['200']} size="14px" />
                    </Box>
                    <Stack
                        direction="column"
                    >
                        <Typography variant="subtitle1" fontWeight="bold">Basic Plan</Typography>
                        <Typography variant="subtitle2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem repudiandae temporibus quam repellat veniam facilis ex illum dolore odio assumenda?</Typography>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}
